export type CountdownColor = 'green' | 'orange' | 'red'

class TimeSpanColorFormat {
  constructor(
    public text: string,
    public color: CountdownColor
  ) {}
}

export const TimeSpanCalculator = {
  process(duration: plugin.Duration, isAstPast?: boolean): TimeSpanColorFormat {
    const prefix = isAstPast ? '-' : ''

    const days = Math.abs(duration.days())
    const hours = Math.abs(duration.hours())

    if ((days || 0) > 0) {
      return new TimeSpanColorFormat(
        `${prefix}${days}d${hours > 0 ? ` ${hours}h` : ''}`,
        isAstPast ? 'red' : 'green'
      )
    }

    const minutes = Math.abs(duration.minutes())

    if ((hours || 0) >= 1) {
      return new TimeSpanColorFormat(
        `${prefix}${hours}h${minutes > 0 ? ` ${minutes}m` : ''}`,
        isAstPast ? 'red' : 'green'
      )
    }

    if ((minutes || 0) >= 10) {
      return new TimeSpanColorFormat(`${prefix}${minutes}m`, isAstPast ? 'red' : 'green')
    }

    const seconds = Math.abs(duration.seconds())

    if ((minutes || 0) >= 3) {
      const shouldDisplayRedBulb = minutes < 3
      return new TimeSpanColorFormat(
        `${prefix}${minutes}m${seconds > 0 ? ` ${seconds}s` : ''}`,
        isAstPast || shouldDisplayRedBulb ? 'red' : 'orange'
      )
    }

    if (minutes !== 0 && seconds !== 0) {
      return new TimeSpanColorFormat(`${prefix}${minutes}m ${seconds}s`, 'red')
    }

    if (minutes !== 0 && seconds === 0) {
      return new TimeSpanColorFormat(`${prefix}${minutes}m`, 'red')
    }

    if (minutes === 0 && seconds !== 0) {
      return new TimeSpanColorFormat(`${prefix}${seconds}s`, 'red')
    }

    return new TimeSpanColorFormat('0s', 'red')
  },
} as const
